module.exports = __webpack_public_path__ + "img/usa.7b674580.svg";